import Review from "../../model/Review";
import {Box, FormControlLabel, IconButton, Radio, Tooltip, Typography, useTheme} from "@mui/material";
import {globalColors} from "../../styles/globalStyles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import EditIcon from "@mui/icons-material/Edit";
import * as React from "react";
import IconicButton from "../../components/controls/IconicButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import {useEffect, useState} from "react";
import {useResources} from "../../stores/ResourceProvider";


const ReviewMenu = ({
  value,
  options,
  onChange,
  onEdit,
  onNew,
  onDelete
} : {
  value?: Review
  options: Review[]
  onChange(option: Review): void
  onEdit?(option: Review): void
  onNew?(): void
  onDelete?(option: Review): void
}) => {
  const [canAddModel, setCanAddModel] = useState<boolean>(true)

  const { userStore } = useResources()

  useEffect(() => {
    if (userStore.isAdvisorOrAdmin) {
      setCanAddModel(true)
    }
  }, [options, userStore.isLoading])

  const theme = useTheme()
  const styles = {
    checkedIcon: {
      height: 20,
      width: 20,
      color: theme.palette.action.active
    },
    uncheckedIcon: {
      color: theme.palette.action.disabled,
      height: 20,
      width: 20
    },
    primaryIcon: {
      height: 20,
      width: 20,
      color: globalColors.primaryModel
    },
    nonPrimaryIcon: {
      height: 20,
      width: 20,
      color: globalColors.nonPrimaryModel
    }
  }

  const handleClose = () => {

  }

  const renderOption = (option: Review) => {
    const current = value && option.id === value.id

    return (
      <Box display="flex" flexDirection="row" key={option.id} py={0} my={0}>
        <Box display="flex" flexGrow={1} minWidth={248} flexDirection="row">
          <FormControlLabel
            control={
                <Radio checked={current}
                       checkedIcon={<VisibilityIcon sx={styles.checkedIcon}/>}
                       icon={<VisibilityOffIcon sx={styles.uncheckedIcon}/>}
                       onChange={(event: any) => {
                         if (event.target.checked) {
                           onChange(option)
                         }}}
                       onClick={(event: any) => handleClose()}
                       sx={{paddingTop:"0px", paddingBottom:"0px"}}
                />
            }
            label={
              <Typography variant="body2" sx={{fontSize:15, whiteSpace:"normal", lineHeight:1.1}}>{option.getReviewTitle()}</Typography>
            }
          />
        </Box>
        <Box display="flex" alignItems="center" justifyContent="flex-end">
          <Box width={32}>
            <Tooltip title="Edit" placement="top">
              <IconButton id={`${option.id}-edit-btn`} size="small"
                          sx={{paddingTop:0, paddingBottom:0}}
                          onClick={(event: any) => {
                            if (onEdit) {
                              onEdit(option)
                            }}}
              >
                <EditIcon sx={{width:18, height:18}}/>
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <Box display="flex" flexDirection="column" width="100%" p={0} mt={0.5} sx={{zIndex: theme.zIndex.drawer + 1}}>
      {options.map((option: Review) =>
        renderOption(option)
      )}
      {canAddModel &&
        <Box display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center" pl={3} pt={0} mt={0} bgcolor={theme.palette.background.paper}>
          <IconicButton label="New Review" labelPosition="right"
                        onClick={(event: any) => {
                          handleClose()
                          if (onNew) {
                            onNew()
                          }}}>
            <AddCircleIcon sx={{color: theme.palette.secondary.light, paddingRight:"2px"}}/>
          </IconicButton>
        </Box>
      }
    </Box>
  )
}

export default ReviewMenu